const ListOfItemsConfig = [
    { span: 6, height: "27px", classes: "marginTop-24" },
    { span: 6, height: "18px", classes: "marginTop-16" },
    { span: 14, height: "96px", classes: "marginTop-16" },
    { span: 14, height: "96px", classes: "marginTop-16" },
    { span: 14, height: "96px", classes: "marginTop-16" },
]

export default ListOfItemsConfig
